import React, { useState } from 'react'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { PencilSquareIcon, XMarkIcon } from '@heroicons/react/16/solid'
import { Separator } from '@/components/ui/separator'
import { Button } from '@/components/ui/button'
import { useForm } from 'react-hook-form'

export default function EditTeam({ teamId }: { teamId: number }) {
  const [open, onOpenChange] = useState(false)
  const { handleSubmit } = useForm()

  function onSubmit() {
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button
          className="h-max w-max p-[2px]"
          iconOnly
          variant="ghost"
          title="Edit space"
        >
          <PencilSquareIcon />
        </Button>
      </DialogTrigger>

      <DialogContent
        onSubmit={handleSubmit(onSubmit)}
        className="max-h-[37.5rem] min-h-[15rem]"
        as="form"
      >
        <DialogHeader>
          <DialogTitle>Update Space</DialogTitle>
          <DialogClose>
            <XMarkIcon />
          </DialogClose>
        </DialogHeader>
        <Separator />
        <DialogBody className="flex flex-col gap-4">
          <div className="flex flex-col gap-4">Edit form goes here</div>
        </DialogBody>
        <Separator />
        <DialogFooter>
          <DialogClose asChild>
            <Button type="button" variant="secondary">
              Cancel
            </Button>
          </DialogClose>

          <Button loading={false}>Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
